module.exports = __webpack_public_path__ + "static/img/ai_white.0e818497.png";